import React, { useEffect, useRef } from 'react'
import styles from './index.module.css'

type Props = {
  children: React.ReactNode
  onStuckChange?: (...args: Array<any>) => any
  zIndex?: number
}

/**
 * A sticky component that makes its content stick to the top of the viewport when scrolling
 * @param children - The content to make sticky
 * @param onStuckChange - Optional callback called when the sticky state changes
 * @param zIndex - Optional z-index value for the sticky element
 * @returns A sticky container that remains at the top of the viewport when scrolling
 */
const Sticky = ({
  children,
  onStuckChange,
  zIndex,
}: Props): React.ReactElement<'div'> => {
  const ref = useRef(null)
  useEffect(() => {
    const scrollHandler = () => {
      if (ref.current && onStuckChange) {
        onStuckChange(
          Boolean(
            window.scrollY && ref.current.getBoundingClientRect().top === 0,
          ),
        )
      }
    }

    document.addEventListener('scroll', scrollHandler)
    return () => {
      document.removeEventListener('scroll', scrollHandler)
    }
  }, [ref.current])
  return (
    <div
      className={styles.sticky}
      ref={ref}
      style={{
        zIndex,
      }}
    >
      {children}
    </div>
  )
}

export default Sticky
